export default __webpack_public_path__ + "static/media/about-image-01.9c853b3a.svg";